export const ACTIONSHEET = {
	PLACEHOLDER: 'placeholder',
	BOOKING_OPTIONS_MENU: 'bookingOptionsMenu',
	NEW_BOOKING_MENU: 'newBookingMenu',
	UNSCHEDULED_INVITATIONS_MENU: 'unscheduledInvitationsMenu',
	VISITOR_MEETING_MENU: 'visitorMeetingMenu',
	QR_CODE_SCANNER_MENU: 'qrCodeScannerMenu',
	SESSION_MENU: 'sessionMenu',
	AGENDA_ITEM: 'agendaItemMenu',
};
